export const DOWN_AND_DISTANCE = 'DOWN & DISTANCE';
export const FIELD_ZONE = 'FIELD ZONE';
export const DOWN_DISTANCE_CODE = 1;
export const FIELD_ZONE_CODE = 2;

export const DOWN_DISTANCE_MAP = {
  Name: 'name',
  Down: 'operand1Value',
  'Min Distance': 'operand2Min',
  'Max Distance': 'operand2Max',
};

export const FIELD_ZONE_MAP = {
  Name: 'name',
  'Min Distance': 'operand1Min',
  'Max Distance': 'operand1Max',
};

export const DOWN_DISTANCE_VALUES = ['name', 'operand1Value', 'operand2Min'];
export const FIELD_ZONE_VALUES = ['name', 'operand1Min', 'operand1Max'];
